// extracted by mini-css-extract-plugin
module.exports = {"heading":"H2Tag_heading__7HVbr"};